import React from 'react';
import { Link } from 'react-router-dom';

import LegalPage from '../_gateway/LegalPage';
import { LAST_UPDATED, policySections } from './app-privacy-content';

const bodyStyle = { fontFamily: 'var(--gw-font-sans)', fontSize: 16, lineHeight: 1.7, color: '#374151' };
const headingStyle = { margin: '36px 0 10px', fontSize: 20, fontWeight: 800, letterSpacing: '-0.01em', color: '#1c2b4a' };

// Show the app's date (e.g. "September 16, 2026") as "16 September 2026" to match the other legal pages
const formatDate = (value) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString('en-IE', { day: 'numeric', month: 'long', year: 'numeric' });
};

// Turn email addresses and web addresses in the policy text into links
const LINK_PATTERN = /([\w.+-]+@[\w-]+(?:\.[\w-]+)+|https?:\/\/[^\s)]+|www\.[\w-]+\.[\w./-]+[\w/])/g;

const Linkified = ({ text }) => text.split(LINK_PATTERN).map((part, i) => {
  if (i % 2 === 0) return part;
  if (part.includes('@')) return <a key={i} href={`mailto:${part}`}>{part}</a>;
  const href = part.startsWith('http') ? part : `https://${part}`;
  return <a key={i} href={href} target="_blank" rel="noopener noreferrer">{part}</a>;
});

const PrivacyPolicy = () => (
  <LegalPage title="PRM Assist App Privacy Policy" lastUpdated={formatDate(LAST_UPDATED)} draftNotice={false}>
    <div style={bodyStyle}>
      <p style={{ marginTop: 28 }}>
        This is the privacy policy for the PRM Assist passenger app. It is the same policy shown in the app. For how we use data when you
        visit www.prmassist.com, see our <Link to="/website-privacy">Website Privacy Policy</Link>.
      </p>

      {policySections.map((section, i) => (
        <section key={i}>
          {section.heading && <h2 style={headingStyle}>{section.heading}</h2>}
          {section.body && <p><Linkified text={section.body} /></p>}
          {section.bullets && (
            <ul style={{ margin: '8px 0 16px', paddingLeft: 22 }}>
              {section.bullets.map((bullet, j) => (
                <li key={j} style={{ marginBottom: 6 }}><Linkified text={bullet} /></li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  </LegalPage>
);

export default PrivacyPolicy;
